export default __webpack_public_path__ + "static/media/close.b2ca272d.svg";